var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer bg-white px-6 py-5"},[_c('span',{staticClass:"text-md font-bold"},[_vm._v(" Business Tech Services, LLC ")])])}]

export { render, staticRenderFns }